import useMediaQuery from "@material-ui/core/useMediaQuery";

import { breakpoints } from "../components/shared";

export const gridItemSpacing = ({
    mobileMaxPadding,
    tabletMaxPadding,
    desktopMinPadding
}) => {
    const mobileMax = useMediaQuery(
        `(min-width:${breakpoints.sm}rem) and (max-width: ${breakpoints.beforeTablet}rem)`
    );

    const tabletMax = useMediaQuery(
        `(min-width:${breakpoints.md}rem) and (max-width: ${breakpoints.beforeDesktop}rem)`
    );

    const desktopMin = useMediaQuery(`(min-width:${breakpoints.lg}rem)`);

    if (mobileMax) {
        return mobileMaxPadding;
    } else if (tabletMax) {
        return tabletMaxPadding;
    } else if (desktopMin) {
        return desktopMinPadding;
    }
    return;
};
